import Autor from './Autor';
import AutorSkeleton from './AutorSkeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <AutorSkeleton /> : <Autor {...props} />;
}
